import axios from 'axios';
import { FETCH_EXHIBITORS_URL } from 'appenv';

function fetchAllExhibitors() {
  return axios.get(FETCH_EXHIBITORS_URL).then((result) => result.data.data);
}

export default fetchAllExhibitors;
